//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {
  createBuildingRepairer,
  createBuildingRepairers,
  getProjectBuildingRepairer,
  createProjectBuildingRepairer
} from '../../../api/project';
import SelectRepairerUserView from './select-repairer-user-view';

export default {
  name: 'page-building-repairer',
  components: {SelectRepairerUserView},
  props: {
    projectId: Number,
    organizationId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: [],
      searchInput: {},
      loading: false,
      saving: false,
      columns: [
        // {
        //     title: 'Date',
        //     key: 'date'
        // },
        {type: 'selection', align: 'center', maxWidth: 66},
        {title: '项目分期', key: 'projectStages', align: 'center'},
        {title: '楼栋', key: 'roomStructureName', align: 'center'},
        {title: '房修信息员', key: 'name', align: 'center'},
        {title: '房修工程师', key: 'workerUserName', align: 'center'},
        {title: '维保负责人', key: 'weiBaoUserName', align: 'center'},
        {title: '维保工程师', key: 'weiBaoWorkerUserName', align: 'center'},
        {title: '操作', slot: 'action', align: 'center'}
      ],
      createModal: false,
      selectUserModal: false,
      buildingRepairer: {},
      createListModal: false,
      selection: [],
      projectBuildingRepairer: {},
      projectBuildingRepairerModal: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0
    };
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.getPage();
    },
    pageSizeChange(size) {
      this.pageSize = size;
      this.getPage();
    },
    getPage() {
      const vm = this;
      vm.searchInput.projectId = vm.projectId;
      vm.searchInput.maxResultCount = vm.pageSize;
      vm.searchInput.skipCount = (vm.currentPage - 1) * vm.pageSize;
      vm.loading = true;
      abp.ajax.get('/api/services/app/Project/GetProjectBuildings',
          {
            params: this.searchInput
          }).then(res => {
        vm.data = [];
        vm.data.push(...res.data.result.items);
        vm.totalCount = res.data.result.totalCount;
      }).finally(() => {
        this.loading = false;
      });
    },
    onSelectionChange(selection) {
      // console.log(selection);
      this.selection = selection;
    },
    showCreateModal(row) {
      if (this.organizationId === 0) {
        this.$Message.error('未绑定组织节点！');
        return;
      }
      this.buildingRepairer = {};
      this.buildingRepairer = JSON.parse(JSON.stringify(row));
      this.createModal = true;
    },
    onSelectedUser(data) {
      // console.log(data);
      if (data.businessType === 'user') {
        this.buildingRepairer.userId = data.id;
        this.buildingRepairer.name = data.name;
      } else if (data.businessType === 'workerUser') {
        this.buildingRepairer.workerUserId = data.id;
        this.buildingRepairer.workerUserName = data.name;
      } else if (data.businessType === 'weiBaoUser') {
        //    weiBaoUser weiBaoWorkerUser
        this.buildingRepairer.weiBaoUserId = data.id;
        this.buildingRepairer.weiBaoUserName = data.name;
      } else if (data.businessType === 'weiBaoWorkerUser') {
        this.buildingRepairer.weiBaoWorkerUserId = data.id;
        this.buildingRepairer.weiBaoWorkerUserName = data.name;
      }
      this.selectUserModal = false;
    },
    showSelectUserModal(businessType) {
      this.buildingRepairer.businessType = businessType;
      this.selectUserModal = true;
    },
    onCreateBuildingRepairer() {
      this.saving = true;
      createBuildingRepairer(this.buildingRepairer).then(res => {
        this.createModal = false;
        this.getPage();
      }).finally(() => {
        this.saving = false;
      });
    },
    showCreateListModal(data) {
      if (this.selection.length <= 0) {
        this.$Message.error('请先选择');
        return;
      }
      if (this.organizationId === 0) {
        this.$Message.error('未绑定组织节点！');
        return;
      }
      this.buildingRepairer = data;
      this.createListModal = true;
    },
    showCreateProjectRepairerModal() {
      if (this.organizationId === 0) {
        this.$Message.error('未绑定组织节点！');
        return;
      }
      this.buildingRepairer = {};
      this.buildingRepairer = JSON.parse(JSON.stringify(this.projectBuildingRepairer));

      this.projectBuildingRepairerModal = true;
    },
    onCreateBuildingRepairers() {
      if (this.buildingRepairer.userId === 0 && this.buildingRepairer.workerUserId === 0) {
        return;
      }
      this.selection.forEach(item => {
        item.userId = this.buildingRepairer.userId;
        item.workerUserId = this.buildingRepairer.workerUserId;
        item.weiBaoUserId = this.buildingRepairer.weiBaoUserId;
        item.weiBaoWorkerUserId = this.buildingRepairer.weiBaoWorkerUserId;
      });
      const page = {
        list: this.selection
      };
      this.saving = true;
      createBuildingRepairers(page).then(res => {
        this.createListModal = false;
        this.getPage();
      }).finally(() => {
        this.saving = false;
      });
    },

    getProjectBuildingRepairer() {
      // this.searchInput.projectId = this.projectId;
      // this.loading = true;
      getProjectBuildingRepairer(this.projectId).then(res => {
        this.projectBuildingRepairer = {};
        this.projectBuildingRepairer = res.data.result;
      }).finally(() => {
        // this.loading = false;
      });
    },

    onCreateProjectBuildingRepairer() {
      this.saving = true;
      console.log(this.buildingRepairer);
      createProjectBuildingRepairer(this.buildingRepairer).then(res => {
        this.projectBuildingRepairerModal = false;
        this.getProjectBuildingRepairer();
      }).finally(() => {
        this.saving = false;
      });
    },

    onReset() {
      this.searchInput = {};
      this.pageChange(1);
    }

  },
  created() {
    this.getPage();
    this.getProjectBuildingRepairer();
  }
};
